/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Image, Input, Typography } from 'antd-v5';
import { notificationError } from '../../../../../../../core/actions';

const MAX_FILES_SIZE = 1e9;
const MAX_FILES_SIZE_HUMAN = '1GB';

const NewActivityModal = ({ activity, onClose, onSaveActivity, notes, setNotes, attachments, setAttachments }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [currentAttachment, setCurrentAttachment] = useState(null);
  const flags = useFlags();

  const addNewAttachment = () => {
    const attachment = { id: Math.floor(Math.random() * 1000000), file: null, url: null, description: '', edit: true };
    setCurrentAttachment(attachment);
    setAttachments([...attachments, attachment]);
  };

  const handleSaveAttachment = () => {
    const savedAttachment = { ...currentAttachment, edit: false };
    const filteredAttachments = attachments.map(att => (att.id === savedAttachment.id ? savedAttachment : att));
    setAttachments(filteredAttachments);
    setCurrentAttachment(null);
    setIsEditing(false);
  };

  const handleAttachImage = e => {
    const file = e.target.files[0];
    if (file.size >= MAX_FILES_SIZE) {
      notificationError(`File size exceeds ${MAX_FILES_SIZE_HUMAN}`);
      return;
    }
    setCurrentAttachment({
      ...currentAttachment,
      file,
      url: URL.createObjectURL(file),
    });
    e.target.value = null;
  };

  const saveActivityHandler = () => {
    onSaveActivity(notes);
  };

  return (
    <div
      className="pop-confirm-background"
      id="modal-background"
      onClick={e => {
        if (e.target.id === 'modal-background') {
          onClose();
        }
      }}
    >
      <div
        className="pop-confirm-container rem-pad-width "
        style={{ width: '500px', minHeight: '278px', overflowY: 'hidden' }}
        data-testid="clients__activity-modal--root"
      >
        <div
          className="flex-col-center"
          style={{
            justifyContent: 'flex-start',
            padding: '0 18px 12px 28px',
          }}
        >
          <span className="fs-18 fw-500" style={{ marginTop: '15px' }}>
            {activity?.description}
          </span>
          <Input.TextArea
            className="m-top-30"
            style={{ width: '85%', height: '150px' }}
            disabled={!activity.includeNotes}
            placeholder="Write a note"
            value={notes}
            onChange={e => setNotes(e.target.value)}
          />

          <div className="flex-col-center w-100-P m-top-30">
            {attachments.length > 0 &&
              attachments.map(attachment =>
                !attachment.edit ? (
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }} key={attachment.id}>
                    <div className="flex-row-center" style={{ marginRight: '10px', marginBottom: '10px' }}>
                      <Image
                        src={attachment.url}
                        alt="attachment"
                        style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                        fallback="./test.svg"
                        preview={false}
                      />
                      <Typography className="m-left-30">{attachment.description}</Typography>
                    </div>
                    <div className="flex-row-center">
                      <Button
                        style={{ marginLeft: '30px', marginRight: '10px' }}
                        type="default"
                        disabled={attachments.reduce((acc, att) => acc || att.edit, false)}
                        onClick={() => {
                          setCurrentAttachment(attachment);
                          setAttachments(attachments.map(a => (a.id === attachment.id ? { ...a, edit: true } : a)));
                          setIsEditing(true);
                        }}
                      >
                        Edit
                      </Button>
                      <Button
                        type="text"
                        onClick={() => {
                          setAttachments(attachments.filter(a => a.id !== attachment.id));
                        }}
                      >
                        <FontAwesomeIcon icon={['far', 'trash']} />
                        Remove
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div key={currentAttachment.id} className="flex-row-center" style={{ marginRight: '10px' }}>
                    {currentAttachment.url ? (
                      <div className="flex-col-center" style={{ marginRight: '10px' }}>
                        <Image
                          src={currentAttachment.url}
                          alt="attachment"
                          style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                          fallback="./test.svg"
                          preview={{
                            mask: <FontAwesomeIcon icon={['far', 'trash']} size="1x" />,
                          }}
                          onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                            setCurrentAttachment({ ...currentAttachment, file: null, url: null });
                          }}
                        />
                      </div>
                    ) : (
                      <div
                        className="flex-col-center"
                        style={{
                          cursor: 'pointer',
                          color: '#33AAFC',
                          height: '50px',
                          width: '50px',
                          backgroundColor: '#E6F4FF',
                          borderRadius: '8px',
                          marginRight: '10px',
                        }}
                        onClick={() => document.getElementById('media-input').click()}
                      >
                        <FontAwesomeIcon icon="far fa-paperclip" size="1x" />
                      </div>
                    )}
                    <Input.TextArea
                      placeholder="Describe the file"
                      value={currentAttachment.description}
                      onChange={e => {
                        setCurrentAttachment({ ...currentAttachment, description: e.target.value });
                      }}
                      style={{ width: '200px' }}
                    />
                    <Button
                      style={{ marginLeft: '30px', marginRight: '10px' }}
                      type="primary"
                      disabled={!currentAttachment.file || !currentAttachment.description}
                      onClick={e => {
                        handleSaveAttachment();
                      }}
                      data-testid="clients__activity-modal--attachment-save-button"
                    >
                      Save
                    </Button>
                    <Button
                      type="default"
                      onClick={e => {
                        setCurrentAttachment(null);
                        if (!isEditing) {
                          setAttachments(attachments.filter(a => a.id !== attachment.id));
                        } else {
                          setAttachments(attachments.map(a => (a.id === attachment.id ? { ...a, edit: false } : a)));
                        }
                        setIsEditing(false);
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                ),
              )}
            {flags.files && (
              <div className="flex-row-center w-100-P m-top-30">
                <Button
                  type="dashed"
                  disabled={attachments.length >= 5 || attachments.reduce((acc, att) => acc || att.edit, false)}
                  onClick={e => {
                    addNewAttachment();
                  }}
                >
                  <FontAwesomeIcon icon="far fa-plus" />
                  Add file
                </Button>
                <input
                  id="media-input"
                  type="file"
                  accept=".jpg, .jpeg, .png, .gif, .svg, .pdf"
                  onChange={e => handleAttachImage(e)}
                  style={{ display: 'none' }}
                />
              </div>
            )}
            <div className="flex-row-center" style={{ marginTop: '30px', marginBottom: '8px', gap: '12px' }}>
              <Button size="large" onClick={onClose}>
                Cancel
              </Button>
              <Button
                type="primary"
                size="large"
                onClick={saveActivityHandler}
                data-testid="clients__activity-modal--save-button"
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewActivityModal;
